import React from 'react'

const CourseShimmer = () => {

  
    return (
        <div className=" flex mx-auto my-12 items-center bg-brand_jaguar  overflow-hidden">
    
            {/* flex 1  */}
          <div className="hidden md:block mx-12 ">
          <div  alt="" className='bg-zinc-700 w-[150px] lg:w-[300px] h-[75px] lg:h-[150px] animate-pulse'> </div>
          </div>
    
          {/* flex 2 */}
          <div className="font-outfit py-6 ">
          
            <div className="my-4 lg:w-96 h-6 bg-zinc-700 rounded-3xl text-xl font-semibold uppercase animate-pulse "> </div>
            <div className="my-4 w-44 h-6 bg-zinc-700 rounded-3xl text-xl font-semibold uppercase animate-pulse "> </div>
            <div className="my-4 w-20 h-6 bg-zinc-700 rounded-3xl text-xl font-semibold uppercase animate-pulse "> </div>
            <div className="my-4 w-80 h-6 bg-zinc-700 rounded-3xl text-xl font-semibold uppercase animate-pulse "> </div>
    
    
            <div className="flex text-black justify-start gap-6">
            <div className="my-4 w-20 h-10 bg-zinc-700 rounded-3xl text-xl font-semibold uppercase animate-pulse "> </div>
            </div>
          
    
          </div>
         
          
        </div>
      );
}

export default CourseShimmer